var render = function () {
  var _vm$otpValidationMess, _vm$skipValidationMes;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    staticClass: "otp-modal",
    attrs: {
      "title": "OTP Verification",
      "centered": "",
      "hide-footer": "",
      "id": "Registration-phone-email-verification"
    },
    on: {
      "hidden": _vm.closeModal
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "otp-modal-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.isOpen,
      callback: function callback($$v) {
        _vm.isOpen = $$v;
      },
      expression: "isOpen"
    }
  }, [_c('b-container', {
    staticClass: "otp-modal-container"
  }, [_c('div', {
    staticClass: "otp-modal-content"
  }, [!_vm.skipVerification ? _c('div', [_c('h6', [_vm._v("OTP Validation")]), _c('p', {
    staticClass: "text-muted mb-2"
  }, [_vm._v(" Validate your " + _vm._s(_vm.identifierTypeText) + " via OTP "), _c('br'), _vm._v(" OTP has been sent to "), _c('strong', {
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.identifier))])]), _c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Please enter the 6 digit OTP:")]), _c('div', {
    staticClass: "d-flex otp-inputs-wrapper"
  }, _vm._l(_vm.otpDigits, function (digit, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: _vm.otpDigits[index],
        expression: "otpDigits[index]",
        modifiers: {
          "number": true
        }
      }],
      key: index,
      ref: "otpInputs",
      refInFor: true,
      staticClass: "form-control otp-input",
      attrs: {
        "maxlength": "1",
        "min": "0",
        "max": "9",
        "inputmode": "numeric",
        "pattern": "\\d*",
        "disabled": _vm.otpVerified || _vm.skipVerification || !_vm.enableVerifyandOtp
      },
      domProps: {
        "value": _vm.otpDigits[index]
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) { return; }

          _vm.$set(_vm.otpDigits, index, _vm._n($event.target.value));
        }, function ($event) {
          return _vm.handleOtpInput(index, $event);
        }],
        "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
          return _vm.handleOtpDelete(index, $event);
        }, function ($event) {
          return _vm.preventNonNumeric($event);
        }],
        "paste": function paste($event) {
          return _vm.handlePaste($event);
        },
        "blur": function blur($event) {
          return _vm.$forceUpdate();
        }
      }
    });
  }), 0), _c('div', {
    staticClass: "d-flex mt-4 gap-2 flex-wrap justify-content-center"
  }, [!_vm.skipVerification ? _c('b-button', {
    staticClass: "verify-btn univ-btn m-0",
    attrs: {
      "disabled": !_vm.isOtpComplete || _vm.otpVerificationInProgress || _vm.otpVerified || !_vm.enableVerifyandOtp
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.verifyOtp.apply(null, arguments);
      }
    }
  }, [_vm.otpVerificationInProgress ? _c('span', [_vm._v("Verifying...")]) : _vm.otpVerified ? _c('span', [_vm._v("Verified")]) : _c('span', [_vm._v("Verify OTP")])]) : _vm._e()], 1)]) : _vm._e(), (_vm$otpValidationMess = _vm.otpValidationMessage) !== null && _vm$otpValidationMess !== void 0 && _vm$otpValidationMess.message && _vm.otpAttempted && !_vm.skipVerification ? _c('div', {
    staticClass: "otp-message-container mt-2 form-group"
  }, [_c('div', {
    class: ['validate-message', _vm.otpValidationMessage.type]
  }, [_c('div', {
    class: ['message-indicator', "".concat(_vm.otpValidationMessage.type, "-indicator")]
  }), _c('span', {
    staticClass: "message-text"
  }, [_c('strong', {
    class: "".concat(_vm.otpValidationMessage.type, "-text")
  }, [_vm._v(_vm._s(_vm.otpValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.otpValidationMessage.message) + " ")])])]) : _vm._e(), _c('div', {
    staticClass: "d-flex align-items-center mt-2"
  }, [_vm.showResendOTPButton ? _c('div', {
    staticClass: "resendOTP"
  }, [_c('a', {
    staticClass: "resend ",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.resendOTP.apply(null, arguments);
      }
    }
  }, [_vm.resendOTPInProgress ? _c('span', [_vm._v(" sending")]) : _c('span', [_vm._v("Resend OTP")])])]) : _vm._e(), _vm.showTimerContent ? _c('New-Login-OTP', {
    ref: "otpTimer",
    attrs: {
      "expirySecond": 600,
      "setSpinnerLoader": _vm.otpLoader
    },
    on: {
      "sendOTP": _vm.setresendOTP,
      "timerFinished": _vm.setresendOTP
    }
  }) : _vm._e()], 1), (_vm$skipValidationMes = _vm.skipValidationMessage) !== null && _vm$skipValidationMes !== void 0 && _vm$skipValidationMes.message ? _c('div', {
    staticClass: "skip-message-container form-group"
  }, [_c('div', {
    class: ['validate-message mt-2', _vm.skipValidationMessage.type]
  }, [_c('div', {
    class: ['message-indicator', "".concat(_vm.skipValidationMessage.type, "-indicator")]
  }), _c('span', {
    staticClass: "message-text"
  }, [_c('strong', {
    class: "".concat(_vm.skipValidationMessage.type, "-text")
  }, [_vm._v(_vm._s(_vm.skipValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.skipValidationMessage.message) + " ")])])]) : _vm._e(), _c('div', {
    staticClass: "cancel-save-btns mt-3 d-flex justify-content-center align-items-center  gap-3"
  }, [_c('b-button', {
    staticClass: "btn btn-secondary  cancel-btn mt-0",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "univ-btn m-0",
    attrs: {
      "disabled": !_vm.canSaveChanges
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v(" Save changes ")])], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }